import React from 'react';
import { Tooltip } from '@mui/material';
import { Clock, CheckCircle2, XCircle, PauseCircle, AlertTriangle } from 'lucide-react';
import { Task } from '../../types';

interface TaskStatusIconProps {
  status: Task['status'];
  isPastDue?: boolean;
}

export const TaskStatusIcon: React.FC<TaskStatusIconProps> = ({ status, isPastDue }) => {
  const getIconAndTooltip = () => {
    if (isPastDue) {
      return {
        icon: <AlertTriangle size={20} className="text-red-500" />,
        tooltip: 'Past Due'
      };
    }

    switch (status) {
      case 'completed':
        return {
          icon: <CheckCircle2 size={20} className="text-green-500" />,
          tooltip: 'Completed'
        };
      case 'in-progress':
        return {
          icon: <Clock size={20} className="text-blue-500" />,
          tooltip: 'In Progress'
        };
      case 'blocked':
        return {
          icon: <XCircle size={20} className="text-red-500" />,
          tooltip: 'Blocked'
        };
      default:
        return {
          icon: <PauseCircle size={20} className="text-gray-500" />,
          tooltip: 'Pending'
        };
    }
  };

  const { icon, tooltip } = getIconAndTooltip();

  return (
    <Tooltip title={tooltip} arrow>
      {icon}
    </Tooltip>
  );
};